// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_QD_","cls2":"PaperClaiming-cls2_szi PaperClaiming-cls1_QD_"};